import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-mapfre-slider-buttons',
  templateUrl: './mapfre-slider-buttons.component.html',
  styleUrls: ['./mapfre-slider-buttons.component.scss'],
})
export class MapfreSliderButtonsComponent implements OnInit {
  @Input() isCarouselStart: boolean;
  @Input() isCarouselEnd: boolean;
  @Output() slidePrev: EventEmitter<boolean>;
  @Output() slideNext: EventEmitter<boolean>;

  constructor() {
    this.slidePrev = new EventEmitter();
    this.slideNext = new EventEmitter();
  }

  ngOnInit() { }

  onSlidePrev() {
    this.slidePrev.emit(true);
  }

  onSlideNext() {
    this.slideNext.emit(true);
  }

}
